<template>
    <SimpleTable formclass="Store/form" endpoint="stores" :aditionalColumns="headers" inlineToggle hideDelete>
        <template>
            <h1>Lojas</h1>
            <v-divider class="mb-4" />
        </template>
    </SimpleTable>
</template>

<script>
import SimpleTable from "@/components/core/SimpleTable";
export default {
    components: {
        SimpleTable,
    },
    data() {
        return {
            headers: [
                { text: this.$t("Habilitado"), value: "enable", align: "right", sortable: false },
                { text: this.$t("Cliente"), value: "client", align: "right", sortable: true },
                { text: this.$t("Bairro"), value: "district", align: "right", sortable: true },
                { text: this.$t("Cidade"), value: "city", align: "right", sortable: true },
                { text: this.$t("Nome"), value: "name", align: "right", sortable: true },
                { text: this.$t("Código"), value: "referenceCode", align: "right", sortable: true },
            ],
        };
    },
};
</script>